import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISeason, ISeasonsInitialState, ISeasonsList } from '@types';

import { initialSeasons } from './initialState';

export const seasonsSlice = createSlice({
    name: 'seasons',
    initialState: initialSeasons(),
    reducers: {
        setSeasons(state: ISeasonsInitialState, action: PayloadAction<ISeasonsList>) {
            state.seasonsList = action.payload;
        },

        setSeason(state: ISeasonsInitialState, action: PayloadAction<ISeason | null>) {
            state.season = action.payload;
        },
    },
});
